import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalMultipleChoicePage } from './modal-multiple-choice.page';

const routes: Routes = [
  {
    path: '',
    component: ModalMultipleChoicePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalMultipleChoicePageRoutingModule {}
